import { gql, useQuery } from "@apollo/client";
import Session from "@lib/session";
import { Config, QueryConfigArgs } from "@graphql/api";
import FrameConfig from "@lib/classes/FrameConfig";

const query = (fields: (keyof Config)[]) => gql`
query config($charterProfile: Int, $groupProfile: Int, $mode: String, $serviceArea: Int, $userProfile: Int) {
  ${configSchema(fields)}
}
`;

const variables = () => ({
  charterProfile: Session.getBooking().profiles.charter,
  groupProfile: Session.getBooking().profiles.group,
  mode: new FrameConfig().mode,
  serviceArea: Session.getBooking().serviceArea,
  userProfile: Session.getBooking().profiles.user,
});

export const configSchema = (fields: (keyof Config)[]) => `
  config(charterProfile: $charterProfile, groupProfile: $groupProfile, mode: $mode, serviceArea: $serviceArea, userProfile: $userProfile) {
    id
    ${fields.join("\n")}
  }
`;

export async function getConfig(fields: (keyof Config)[]) {
  return await global.window.apolloClient.query({ query: query(fields), variables: variables() });
}

interface ConfigQuery<T extends keyof Config> {
  __typename?: "Query";
  config: Pick<Config, T>;
}

function useConfig<T extends (keyof Config)[]>(fields: T = []) {
  type Fields = (typeof fields)[number];
  return useQuery<ConfigQuery<Fields>, QueryConfigArgs>(query(fields), { variables: variables() });
}

export default useConfig;
